'use client';

export { default } from './CardHeader';
export { default as cardHeaderClasses } from './cardHeaderClasses';
export * from './cardHeaderClasses';


//////////////////
// WEBPACK FOOTER
// ../@mui/material/CardHeader/index.js
// module id = 908
// module chunks = 25